export const BANNER_TYPES = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};
